<template lang="html">
    <div class="all">
        <h4>New Smart Link</h4>
        <Campaign :onSubmit='submit' :isVta='isVta' />
    </div>
</template>

<script>
import Campaign from '../Campaign'
export default {
    props: {
        isVta: Boolean
    },
    components: {
        Campaign
    },
    methods: {
        submit: async function (form) {
            try {
                const r = await this.$http.post(this.resources.SmartLinksCampaigns.postCampaign, form)
                const created = await r.json()
                created.stats = created.stats || {}
                let camps = this.$store.state.smartlinks
                if (!camps.campaigns) {
                    camps.campaigns = [created]
                } else {
                    camps.campaigns.unshift(created)
                }
                this.$emit('close')
                this.$router.push({
                    name: 'SmartLinksV2Workspace',
                    params: { campId: created.id }
                })
            } catch (err) {
                this.notifyError("Could not create Smart Link")
            }
        }
    }
}
</script>

<style lang="css" scoped></style>
